export const initialFilter = {
  searchText: "",
  sortOrder: "asc",
  sortField: "id",
  pageNumber: 1,
  pageSize: 5,
};
